import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import VueBarcode from 'vue-barcode'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import CryptoJS from 'crypto-js'
import {
	Validator
} from 'vee-validate'
// import Printd from 'printd'
export default {
	name: 'po',
	components: {
		Paginate,
		VueElementLoading,
		'barcode': VueBarcode
	},

	data: function () {
		return {
			urlwarehouseid: '',
			isLoading: false,
			poid: '',
			urlclientid: '',
			loginwarehouseid: 0,
			loginClientUserId: 0,
			listOrderDetailsData: [],
			orderDetailsCount: 0,
			allocatedRacks: [],
			orderModifyDetails: []

		}
	}, // end data
	created: function () {

	},
	filters: {
		moment: function (date) {
			return moment(date).format('DD-MM-YYYY');
		},

	},

	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		var loginuserid = userdetail.userid;
		var loginuseremail = userdetail.email;
		this.loginwarehouseid = userdetail.warehouseid;
		this.loginClientUserId = userdetail.clientid;
		this.getorderItemDetails();
		// 	this.getAllocatedRack();
		// this.getorderDetails();
	},

	methods: {
		getScore(val) {
			if (!val) {
				return 0.00
			}
			return val.toFixed(2);
		},
		dateFormatDetail(date) {
			if (!date) return '';
			return moment(date).format('LLLL');
		},
		getorderItemDetails() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pono = this.$route.params.poid
			this.urlclientid = this.loginClientUserId ? this.loginClientUserId : this.$route.query.clientid
			this.urlwarehouseid = this.loginwarehouseid ? this.loginwarehouseid : this.$route.query.warehouseid
			this.poid = this.pono;
			this.isLoading = true;
			this.input = ({
				pono: this.pono,
				clientid: this.urlclientid,
				warehouseid: this.urlwarehouseid,
				type: "OrderItemDetails"
			});
			//console.log("innnn",this.input);
			axios({
				method: 'POST',
				'url': apiUrl.api_url + 'getSingleOrderDetailsUpdatedForTab',
				'data': this.input,
				headers: {
					'Authorization': 'Bearer ' + myStr
				}
			})
				.then(result => {
					this.listOrderDetailsData = result.data.data.orderDetails;
					this.orderDetailsCount = this.listOrderDetailsData.length;
					this.orderModifyDetails = result.data.data.orderModifyDetails;
					var allocatedRack = result.data.allocatedRack;
					for (var j = 0; j < allocatedRack.length; j++) {

						if (this.allocatedRacks[allocatedRack[j].productid] === undefined) {
							this.allocatedRacks[allocatedRack[j].productid] = allocatedRack[j].rackid;
						} else {
							if (this.allocatedRacks[allocatedRack[j].productid] != allocatedRack[j].rackid) {
								this.allocatedRacks[allocatedRack[j].productid] += ',' + allocatedRack[j].rackid;
							}
						}
					}
					this.isLoading = false;
				},
					error => {
						console.error(error)
					})
		},
		createGoogleLink(imageLink, id) {
			var preURL = 'https://drive.google.com/uc?export=view&id=';
			var validUrl = '';
			var tempUrl = imageLink.value.split('?id=');
			if (tempUrl.length == 1) {
				var tempURL = imageLink.value.split('https://drive.google.com/file/d/');
				var tempURL1 = tempURL[1].value.split('/view');
				var validUrl = preURL + tempURL1[0];
				//this.productimage = validUrl;
				$("#" + id).attr("src", validUrl);
			} else {
				validUrl = preURL + tempUrl[1];
				$("#" + id).attr("src", validUrl);
			}
		},
	} // end methods
}



// WEBPACK FOOTER //
// ./src/views/components/orderdetailstab/orderItemDetails/orderItemDetails.component.js